/**
 * Dialog: confirmar pago de UNA factura individual.
 * Extraído de CxPPanel.jsx en Iter 236.m.14 (Carlos).
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { Check } from 'lucide-react';

const fmt = (n) => `$${Math.round(n || 0).toLocaleString('es-CL')}`;

export function ConfirmarPagoFacturaDialog({ open, factura, busy, onClose, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid="dialog-confirmar-pago-factura" className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Check className="w-5 h-5 text-emerald-600" />
            ¿Marcar factura como PAGADA?
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              {factura && (
                <div className="bg-slate-50 dark:bg-slate-900/40 border rounded p-2.5 space-y-1">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Proveedor:</span>
                    <span
                      className="font-medium truncate ml-2 max-w-[220px]"
                      title={factura.nombre_proveedor}
                    >
                      {factura.nombre_proveedor}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Folio:</span>
                    <span className="font-mono font-semibold">{factura.folio || '—'}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Monto:</span>
                    <span className="font-bold tabular-nums text-emerald-700">
                      {fmt(factura.monto)}
                    </span>
                  </div>
                </div>
              )}
              <ul className="list-disc pl-5 text-[13px] text-muted-foreground space-y-0.5">
                {factura?.alegra_id ? (
                  <>
                    <li>
                      Se registrará un <strong>payment-out</strong> en <strong>Alegra</strong>{' '}
                      (Banco de Chile 1).
                    </li>
                    <li>
                      Si Alegra rechaza el pago, la factura quedará pagada en el ERP y aparecerá en
                      el banner ámbar para reintentar.
                    </li>
                    <li>
                      La factura <strong>no volverá a aparecer</strong> en CxP después del próximo
                      sync.
                    </li>
                  </>
                ) : (
                  <li>
                    Factura local sin <code>alegra_id</code> — solo se marca pagada en el ERP, sin
                    push a Alegra.
                  </li>
                )}
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="btn-cancel-pago">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={busy}
            className="bg-emerald-600 hover:bg-emerald-700"
            data-testid="btn-confirmar-pago"
          >
            {busy ? 'Procesando…' : 'Sí, marcar pagada'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
